export function isFieldDefined(inputField) {
  return inputField ? true : false;
}
